import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomRequisitionPrecedent } from '@models/requisitions';
import {
	BaseCustomRequisitionModal,
	INewCustomRequisitionModalData,
} from '../base-custom-requisition-modal';
import { SnackbarService } from '@services/ui/snackbar.service';
import { BusinessRequisitionsDispatch } from '@state/business/requisition/business_requisitions.dispatch';

@Component({
	selector: 'app-edit-custom-requisition-modal',
	templateUrl: './edit-custom-requisition-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class EditCustomRequisitionModalComponent extends BaseCustomRequisitionModal {
	successMessage = 'Custom Requisition Updated Successfully';
	errorMessage = 'Error updating custom requisition';
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: INewCustomRequisitionModalData,
		protected dialogRef: MatDialogRef<
			EditCustomRequisitionModalComponent,
			string
		>,
		protected businessRequisitionDispatch: BusinessRequisitionsDispatch,
		protected snackbarService: SnackbarService,
	) {
		super(data, dialogRef, businessRequisitionDispatch, snackbarService);
	}

	onSubmitAction(requisition: CustomRequisitionPrecedent) {
		this.businessRequisitionDispatch.Update({
			...requisition,
			id: this.data.selectedRequisitionId,
		});
		return requisition;
	}
}
